import React, { useMemo, lazy, Suspense } from "react";

// Lazy load the Products component
const Products = lazy(() => import("../Product/Products"));

function Features() {
  // Memoize the background elements to prevent unnecessary re-renders
  const backgroundElements = useMemo(() => (
    <>
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/10 to-[#543DF4]/10" />
    </>
  ), []);

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Simplified Background */}
      <div className="absolute inset-0">
        {backgroundElements}
      </div>

      <div className="container mx-auto relative z-10">
        <div className="flex justify-center mb-8">
          <span className="inline-block px-6 py-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm text-white/90">
            Our Key Features
          </span>
        </div>

        <h2 className="text-5xl font-normal leading-[1.2] tracking-[0.001em] text-center mb-12 text-white/95"
          style={{ fontFamily: "Neue Montreal" }}>
          Discover how our Lead Generation Tool
          <br />
          <span className="bg-gradient-to-r from-[#C334F6] to-[#543DF4] bg-clip-text text-transparent">
            can boost your success
          </span>
        </h2>

        <div className="relative">
          <Suspense fallback={<div className="h-96 flex items-center justify-center">
            <div className="w-8 h-8 border-4 border-[#C334F6] rounded-full animate-spin"></div>
          </div>}>
            <Products />
          </Suspense>
        </div>
      </div>
    </section>
  );
}

export default React.memo(Features);
